export default {
	'isLength': 'Pole jest wymagane',
	'isEven': 'Liczba musi być parzysta',
	'isEmail': 'Niepoprawny e-mail.',
	'isInt:{\'min\'-1}:{\'max\'-20}' : 'Minimalna liczba produktów to 1, maksymalna 20',
	'isInt:{\'min\'-2}' : 'Przy laminacji minimalna liczba produktów to 2',
	'isInt:{\'min\'-1}' : 'Minimalna ilość produktów to 1'
};


/** WEBPACK FOOTER **
 ** ./js/helpers/validator-messages.js
 **/